import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api_getContentPageSidebarLinks } from '~/backend/api_calls';

export default function Sidebar(props) {
	let url = props.pageurl;
	const { t } = useTranslation();
	const [cmsPages, setCmsPages] = useState({});

	useEffect(() => {
		api_getContentPageSidebarLinks()
			.then(json => {
				setCmsPages(json.items);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	const ShowCmsPages = cms => {
		if (cms != null && cms.length > 0) {
			return cms.map((item, index) => (
				<a className={url == item.value ? 'page-button active' : 'page-button'} key={index} href={item.value}>
					{item.label}
				</a>
			));
		}
		return null;
	};

	return <section id="pages-sidebar">{ShowCmsPages(cmsPages)}</section>;
}

Sidebar.propTypes = {
	pageName: PropTypes.string,
	pageurl: PropTypes.string
};
